/**
 * @module LanguageControl
 */
import './LanguageControl.css';
import { Control } from 'ol/control.js';
import { t } from '../utils/i18n';

class LanguageControl extends Control {
  constructor(opt_options) {
    const options = opt_options || {};

    // Create the container div
    const container = document.createElement('div');
    container.className = 'nhc-map-language-control border-top border-gray-10 padding-y-1 padding-x-2';
    container.innerHTML = `
      <h4>${t("language_select_label")}</h4>
    `;

    super({
      element: container,
      target: options.target,
    });

    this.container = container;
    this.mapManager = options.mapManager;
    this.languages = options.languages || { en: 'English', es: 'Español' };
    this.currentLanguage = options.currentLanguage || 'en';

    const select = document.createElement('select');
    for (const [code, name] of Object.entries(this.languages)) {
      const option = document.createElement('option');
      option.value = code;
      option.textContent = name;
      if (code === this.currentLanguage) {
        option.selected = true;
      }
      select.appendChild(option);
    }

    select.addEventListener('change', (e) => this.handleLanguageChange(e));
    container.appendChild(select);
  }

  /**
   * Updates the language-specific elements.
   */
  updateLanguage() {
    if (!this.container) return;
    // Get the h4 element and change it's contents
    const heading = this.container.querySelector('h4');
    if (heading) {
      heading.textContent = t("language_select_label");
    }
  }

  handleLanguageChange(event) {
    // Find the parent dropdown content container and hide it
    /*
    const dropdownContent = this.element.closest('.nhc-map-dropdown-content');
    if (dropdownContent) {
      dropdownContent.style.display = 'none';
    }
    */

    const newLanguage = event.target.value;
    // Disable the control while the map is updating
    event.target.disabled = true;
    
    this.mapManager.changeLanguage(newLanguage).finally(() => {
      // Re-enable the control when the change is complete
      event.target.disabled = false;
    });
  }
}

export default LanguageControl;